export class DomUtilsService {
  
  static hasInteractiveAncestor(element: HTMLElement, currentTarget: HTMLElement): boolean {
    while (element && element !== currentTarget) {
      if (element instanceof HTMLAnchorElement || element instanceof HTMLButtonElement || element instanceof SVGElement) {
        return true;
      } else {
        element = element.parentElement!;
      }
    }
    return false;
  }
}
